import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBoostActive = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 20 20",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M6.875 11.725a.626.626 0 1 1 0 1.25H4.634l1.142 1.142a6.25 6.25 0 0 0 8.788.052.624.624 0 0 1 .874.893 7.45 7.45 0 0 1-5.24 2.136h-.042a7.46 7.46 0 0 1-5.263-2.197L3.75 13.858V16.1a.626.626 0 1 1-1.25 0v-3.75a.626.626 0 0 1 .625-.625zM10 5c1.072 0 2.063.34 2.877.913a1.46 1.46 0 0 0-.677.309l-.106.096a1.46 1.46 0 0 0 1.031 2.49h1.73q.143.574.145 1.192a5 5 0 0 1-8.24 3.808h.115a1.459 1.459 0 1 0 0-2.916H5.081A5 5 0 0 1 10 5m-.15-2.5a7.5 7.5 0 0 1 5.26 2.198l1.14 1.143V3.6a.626.626 0 1 1 1.25 0v3.75a.626.626 0 0 1-.625.625h-3.75a.626.626 0 1 1 0-1.25h2.241l-1.142-1.143a6.22 6.22 0 0 0-4.386-1.831h-.035a6.21 6.21 0 0 0-4.366 1.78.625.625 0 0 1-.874-.894A7.5 7.5 0 0 1 9.85 2.5"
	})
});
export default SvgBoostActive;
